const fileInput = document.querySelectorAll('.file-input');

if (fileInput) {
  fileInput.forEach((input) => {
    input.addEventListener('change', (e) => {
      e.target.parentNode.querySelector("label > span").textContent = e.target.files[0].name;
    })
  })
}
